import React from 'react';
import { flexRender, Modal } from '@panwds/react-ui';
import { useWizardState } from './useWizardState.esm.js';
import { WizardProvider } from './WizardContext.esm.js';

/**
 * Wizards are multi-step forms for complex workflows.
 *
 * Steps are passed as an array of config objects. See `WizardStepState`.
 *
 * The "Component" for each step can be built independently. Most will use the `WizardForm` component.
 *
 * See how each individual step is constructed in the examples below and combined together in the [WizardWorkflow](#wizard-workflow) example.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { FormLayout, WizardForm, Wizard } from '@panwds/react-form';
 * ```
 */
function Wizard({ context: userContext, initialActiveIndex, steps: initialSteps, title, ...modalProps }) {
    const context = useWizardState({
        initialState: {
            activeIndex: initialActiveIndex,
            isDirty: false,
            steps: initialSteps,
            title,
        },
    });
    const { state: { activeIndex, isDirty, steps }, } = context;
    const step = flexRender(steps[activeIndex].Component, {
        context: userContext,
    });
    return (React.createElement(Modal, { confirmClose: isDirty, eventsToClose: {
            enableClickOutside: false,
            enableEscapeKey: true,
        }, ...modalProps },
        React.createElement(WizardProvider, { context: context }, step)));
}

export { Wizard };
//# sourceMappingURL=Wizard.esm.js.map
